// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"31c0ada9","422":"2a7d7282","550":"b344e16f","860":"937de5aa"}[chunkId] + ".chunk.js";
};